import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";

const baseState = state => state.event.single;

export const singleEventLoading = createSelector([baseState], (state) => {
    return state.status === ReducerStatuses.LOADING;
});
export const singleEventErrorSelector = createSelector([baseState], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    };
});
export const singleEventData = createSelector([baseState], (state) => {
    return state.event;
});